<template>
  <AddColor />
</template>

<script>
import AddColor from '@/components/product/stockModules/addColor.vue'
export default {
  components: {
    AddColor,
  },
}
</script>
